import { AuthContextType } from "../features/auth/AuthContext";
import { apiWithTimeout } from "../shared/api/timeout";
import { apiHost, getErrorMessage } from "../shared/api/helpers";

export interface ShopLoginInfoPayload {
    market_site: string;
    login_id: string;
    login_pw: string;
}

export async function fetchShopLoginInfos(opts: {
    auth: AuthContextType,
    setErrorMessage?: (arg: any) => void,
    setResult?: (arg: any) => void,
}) {
    const { auth, setErrorMessage, setResult } = opts;
    try {
        const response = await apiWithTimeout.quick.get(`${apiHost}/api/shoplogininfos/`);
        if (response.data && setResult) {
            setResult(response.data);
        }
    } catch (error: any) {
        if (error.response?.status === 401) {
            await auth?.logout();
            return;
        }
        const message = getErrorMessage(error);
        if (setErrorMessage) {
            setErrorMessage(message);
        } else {
            console.error(message);
        }
    }
}

export async function createShopLoginInfo(opts: {
    auth: AuthContextType,
    payload: ShopLoginInfoPayload,
    setErrorMessage?: (arg: any) => void,
    setProcessMessage?: (arg: any) => void,
    setResult?: (arg: any) => void,
}) {
    const { auth, payload, setErrorMessage, setProcessMessage, setResult } = opts;
    try {
        setProcessMessage && setProcessMessage("저장 중입니다...");
        const response = await apiWithTimeout.normal.post(`${apiHost}/api/shoplogininfos/`, payload);
        if (response.data && setResult) {
            setResult(response.data);
        }
    } catch (error: any) {
        if (error.response?.status === 401) {
            auth?.logout();
            return;
        }
        const message = getErrorMessage(error);
        if (setErrorMessage) {
            setErrorMessage(message);
        } else {
            console.error(message);
        }
        throw error;
    } finally {
        setProcessMessage && setProcessMessage(null);
    }
}

export async function updateShopLoginInfo(opts: {
    auth: AuthContextType,
    id: string,
    payload: ShopLoginInfoPayload,
    setErrorMessage?: (arg: any) => void,
    setProcessMessage?: (arg: any) => void,
    setResult?: (arg: any) => void,
}) {
    const { auth, id, payload, setErrorMessage, setProcessMessage, setResult } = opts;
    try {
        setProcessMessage && setProcessMessage("저장 중입니다...");
        const response = await apiWithTimeout.normal.patch(`${apiHost}/api/shoplogininfos/${id}/`, payload);
        if (response.data && setResult) {
            setResult(response.data);
        }
    } catch (error: any) {
        if (error.response?.status === 401) {
            auth?.logout();
            return;
        }
        const message = getErrorMessage(error);
        if (setErrorMessage) {
            setErrorMessage(message);
        } else {
            console.error(message);
        }
        throw error;
    } finally {
        setProcessMessage && setProcessMessage(null);
    }
}

export async function deleteShopLoginInfo(opts: {
    auth: AuthContextType,
    id: string,
    setErrorMessage?: (arg: any) => void,
    setProcessMessage?: (arg: any) => void,
    setResult?: (arg: any) => void,
}) {
    const { auth, id, setErrorMessage, setProcessMessage, setResult } = opts;
    try {
        setProcessMessage && setProcessMessage("삭제 중입니다...");
        await apiWithTimeout.normal.delete(`${apiHost}/api/shoplogininfos/${id}/`);
        setResult && setResult(true);
    } catch (error: any) {
        if (error.response?.status === 401) {
            auth?.logout();
            return;
        }
        const message = getErrorMessage(error);
        if (setErrorMessage) {
            setErrorMessage(message);
        } else {
            console.error(message);
        }
        throw error;
    } finally {
        setProcessMessage && setProcessMessage(null);
    }
}
